import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetMyOnboardingPlanQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyOnboardingPlanQuery = { __typename?: 'Query', myOnboardingPlan: { __typename?: 'OnboardingPlanData', upload: { __typename?: 'OnboardingPlanUploadData', canAct: boolean, completedCount: number, totalCount: number, families: Array<{ __typename?: 'OnboardingPlanFamilyData', existingCount: number, family: string, latestRunState?: Types.OnboardingJourneyRunState | null, nextAction: Types.OnboardingPlanNextAction, openQuestionCount: number }> }, learn: { __typename?: 'OnboardingPlanLearnData', completedCount: number, totalCount: number, nextConcept?: { __typename?: 'LearningConcept', module: Types.LearningModule, conceptId: string, titleKey: string, summaryKey: string, docsPath: string, walkthroughId?: string | null, isComplete: boolean, milestone?: { __typename?: 'LearningMilestone', eventTypes: Array<string> } | null, progress: { __typename?: 'LearningConceptProgress', explainedAt?: Types.TDateISO | null, milestoneObservedAt?: Types.TDateISO | null } } | null, upcomingConcepts: Array<{ __typename?: 'LearningConcept', conceptId: string, titleKey: string, summaryKey: string, docsPath: string, walkthroughId?: string | null, isComplete: boolean, milestone?: { __typename?: 'LearningMilestone', eventTypes: Array<string> } | null, progress: { __typename?: 'LearningConceptProgress', explainedAt?: Types.TDateISO | null, milestoneObservedAt?: Types.TDateISO | null } }> } } };


export const GetMyOnboardingPlanDocument = new TypedDocumentString(`
    query GetMyOnboardingPlan {
  myOnboardingPlan {
    upload {
      canAct
      completedCount
      totalCount
      families {
        existingCount
        family
        latestRunState
        nextAction
        openQuestionCount
      }
    }
    learn {
      completedCount
      totalCount
      nextConcept {
        ...LearningPathConcept
        module
      }
      upcomingConcepts {
        ...LearningPathConcept
      }
    }
  }
}
    fragment LearningPathConcept on LearningConcept {
  conceptId
  titleKey
  summaryKey
  docsPath
  walkthroughId
  isComplete
  milestone {
    eventTypes
  }
  progress {
    explainedAt
    milestoneObservedAt
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMyOnboardingPlan: build.query<GetMyOnboardingPlanQuery, GetMyOnboardingPlanQueryVariables | void>({
      query: (variables) => ({ document: GetMyOnboardingPlanDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMyOnboardingPlanQuery, useLazyGetMyOnboardingPlanQuery } = injectedRtkApi;
